import React, { Fragment, useEffect, useState } from 'react';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { Add, Assignment } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';

import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { FormControl, MenuItem, Select, TextField } from '@material-ui/core';
import { onlyMoney } from 'hooks/Pipe';
import { wsUpdate, wsFindBy } from 'services/WService';
import { Autocomplete } from '@material-ui/lab';
import ModalBase from 'components/Tvendo/Common/ModalBase';
import { useModal } from 'hooks/useModal';
import ButtonDelete from 'hooks/ButtonDelete';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: '500'
  },
  general: {
    marginTop: '15px',
    marginBottom: '17px',
    '& h6': {
      fontSize: '11px',
      marginBottom: '0px'
    }
  },
  tr: {
    backgroundColor: '#b333d5',
    '& th': {
      color: 'white'
    }
  },
  tableRow: {
    '& > *': {
      borderBottom: 'unset'
    }
  }
});

export default function CategoryGroup(props) {
  const classes = useStyles();
  const { provider, showNotify, reload, groupType } = props;

  const [model, setOpen] = useModal();

  return (
    <Card>
      <ModalAddCategory
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        reload={reload}
        incentiveId={provider.com_incentive_id}
        provider={provider}
      />

      <CardHeader icon>
        <CardIcon
          color={groupType === 'M' ? 'success' : 'primary'}
          pointer={groupType === 'M'}
          onClick={() => {
            if (groupType === 'M') setOpen(true);
          }}
        >
          {groupType === 'M' ? <Add /> : <Assignment />}
        </CardIcon>
        <h4 className={classes.cardIconTitle}>
          {`${groupType === 'M' ? 'MASIVO' : groupType === 'F' ? 'EXTRAS - PROD. FOCO' : '-'} - (${
            provider.CardCode || ''
          } - ${provider.CardName || ''})`}
        </h4>
      </CardHeader>
      <CardBody>
        <GridContainer className={classes.general}>
          <GridItem xs={12} md={2} lg={2}>
            <h6>Descripción</h6>
            <span>{provider.description}</span>
          </GridItem>
          <GridItem xs={12} md={2} lg={2}>
            <h6>% Peso</h6>
            <span>{provider.percentage_weight}</span>
          </GridItem>
          <GridItem xs={12} md={2} lg={2}>
            <h6>Rango mínimo</h6>
            <span>{provider.min_range}</span>
          </GridItem>
          <GridItem xs={12} md={2} lg={2}>
            <h6>Rango máximo</h6>
            <span>{provider.max_range}</span>
          </GridItem>
          <GridItem xs={12} md={12} lg={12} style={{ marginTop: '20px' }}>
            <hr style={{ margin: 0 }} />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12}>
            <div
              style={{
                borderWidth: '2px',
                borderStyle: 'solid',
                borderImage: 'linear-gradient(to top, white, #b333d5) 1',
                borderRadius: '2px'
              }}
            >
              <Table aria-label="collapsible table" size="small">
                <TableHead>
                  <TableRow className={classes.tr}>
                    <TableCell />
                    <TableCell>Descripción</TableCell>
                    <TableCell align="center">Válido para jefe</TableCell>
                    <TableCell align="center" width="400">
                      Recompenza jefe
                    </TableCell>
                    <TableCell align="center">Eliminar</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {provider.categories.map((cat, i) => (
                    <RowCategory
                      key={i}
                      category={{
                        ...cat,
                        boss_reward: parseFloat(cat.boss_reward || 0).toFixed(2)
                      }}
                      providerId={provider.LineNum}
                      showNotify={showNotify}
                      reload={reload}
                    />
                  ))}
                </TableBody>
              </Table>
            </div>
          </GridItem>
        </GridContainer>
      </CardBody>
    </Card>
  );
}

const RowCategory = (props) => {
  const classes = useStyles();
  const { category, providerId, showNotify, reload } = props;
  const [open, setOpen] = useState(false);

  const [valCategory, setValCategory] = useState(category);

  const handleChange = (e) => {
    setValCategory({ ...valCategory, [e.target.name]: e.target.value });
  };

  async function updateCategory(e) {
    if (!!category && category[e.target.name] == e.target.value) return;

    let data = { [e.target.name]: e.target.value };
    if (e.target.name === 'boss_valid_reward') {
      data.boss_valid_reward = data.boss_valid_reward === 'Y' ? true : false;
    }

    let response = await wsUpdate(
      `com/incentive/${category.com_incentive_id}/provider/${providerId}/category`,
      category.LineNum,
      data
    );

    if (response.success) {
      showNotify(response.message);
      reload();
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    if (category.LineNum) setValCategory(category);
  }, [category]);

  return (
    <Fragment>
      <TableRow className={classes.tableRow} style={{ backgroundColor: open ? '#fef3ff' : '' }}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>{category.item_description}</TableCell>
        <TableCell align="center">
          <FormControl
            fullWidth
            margin="normal"
            size="small"
            required
            style={{ marginTop: 0, marginBottom: '3px' }}
          >
            <Select
              defaultValue={valCategory.boss_valid_reward ? 'Y' : 'N' || ''}
              inputProps={{
                name: 'boss_valid_reward',
                onChange: updateCategory
              }}
            >
              <MenuItem value="Y">Si</MenuItem>
              <MenuItem value="N">No</MenuItem>
            </Select>
          </FormControl>
        </TableCell>
        <TableCell align="right">
          <InputField
            type="number"
            name="boss_reward"
            value={valCategory.boss_reward || ''}
            onChange={handleChange}
            onBlur={updateCategory}
            onKeyPress={onlyMoney}
            inputProps={{ min: 0, step: 0.01 }}
          />
        </TableCell>
        <TableCell align="center">
          <ButtonDelete
            entity={`com/incentive/${category.com_incentive_id}/provider/${providerId}/category`}
            id={category.LineNum}
            reload={reload}
            style={{ height: '0px' }}
          />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={5}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Table
                size="small"
                aria-label="purchases"
                border="true"
                style={{ border: '1px solid #dbdada' }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      Minorista
                    </TableCell>
                    <TableCell colSpan={2} align="center">
                      Mayorista
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    {category.rewards.map((rew, i) => (
                      <TableCell key={i}>
                        {rew.indicator_type === 'V'
                          ? 'Premio Volumen'
                          : rew.indicator_type === 'C'
                          ? 'Premio Cobertura'
                          : 'Otro'}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    {category.rewards.map((rew, i) => (
                      <Reward
                        key={i}
                        reward={{ ...rew, reward: parseFloat(rew.reward).toFixed(2) }}
                        reload={reload}
                        showNotify={showNotify}
                      />
                    ))}
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
};

const Reward = (props) => {
  const { reward, reload, showNotify } = props;

  const [valReward, setValReward] = useState(reward);

  const handleChange = (e) => {
    setValReward({ ...valReward, [e.target.name]: e.target.value });
  };

  async function updateReward(e) {
    if (!!reward && reward[e.target.name] == e.target.value) return;

    let response = await wsUpdate(`com/incentive/${reward.com_incentive_id}/reward`, {
      rewards: [{ reward_id: reward.id, [e.target.name]: e.target.value }]
    });
    if (response.success) {
      showNotify(response.message);
      reload();
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    if (reward.id) setValReward(reward);
  }, [reward]);

  return (
    <TableCell>
      <InputField
        type="number"
        name="reward"
        value={valReward.reward || ''}
        onChange={handleChange}
        onBlur={updateReward}
        onKeyPress={onlyMoney}
        inputProps={{ min: 0, step: 0.01 }}
      />
    </TableCell>
  );
};

const InputField = (props) => {
  return (
    <TextField
      {...props}
      style={{ marginTop: 0, marginBottom: '3px', float: 'right' }}
      margin="normal"
      size="small"
      fullWidth
      inputProps={{ style: { textAlign: 'right' } }}
    />
  );
};

const ModalAddCategory = (props) => {
  const { incentiveId, provider, model, setOpen, showNotify, reload } = props;

  const [dataChanging, setDataChanging] = useState({});
  const [categories, setCategories] = useState([]);

  async function listCategories() {
    let response = await wsFindBy('logi/category', {
      base_business_partner_id: provider?.base_business_partner_id
    });
    if (response.success) setCategories(response.data);
  }

  useEffect(() => {
    if (provider?.base_business_partner_id && model.open) listCategories();
  }, [model.open]);

  return (
    <ModalBase
      title={`${provider?.CardCode} - ${provider?.CardName}`}
      model={{ open: model.open }}
      setOpen={setOpen}
      showNotify={showNotify}
      reload={reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      entity={`com/incentive/${incentiveId}/provider/${provider?.LineNum}/category`}
    >
      <Autocomplete
        disableClearable
        options={categories}
        getOptionLabel={(option) => option.description}
        renderInput={(params) => (
          <TextField {...params} label="Categoría" margin="normal" required />
        )}
        onChange={(e, item) => setDataChanging({ logi_category_id: item.id })}
      />
    </ModalBase>
  );
};
